import PropTypes from 'prop-types';
import './Loading.css';

export default function Loading({ fullScreen = false, text = 'Loading...', size = 'md' }) {
    const content = (
        <div className={`loading loading-${size}`}>
            <div className="loading-spinner" />
            {text && <span className="loading-text">{text}</span>}
        </div>
    );

    if (fullScreen) {
        return <div className="loading-fullscreen">{content}</div>;
    }

    return content;
}

Loading.propTypes = {
    fullScreen: PropTypes.bool,
    text: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'md', 'lg'])
};
